import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';

class ChooseOneResultsSectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string,
        chooseOneQuestionDataSource: PropTypes.array,
        assetLinkOptions: PropTypes.array,
        isGlobalSectionItem: PropTypes.bool
    };

    render() {
        const { memberReference, chooseOneQuestionDataSource, isGlobalSectionItem } = this.props;
        return (
            <Fragment>
                <div className={'row'}>
                    <Field
                        name={
                            memberReference
                                ? `${memberReference}.content.chooseOneSectionItemId`
                                : 'content.chooseOneSectionItemId'
                        }
                        label={'Referenced Choose One Question'}
                        options={chooseOneQuestionDataSource}
                        valueKey={'_id'}
                        labelKey={'name'}
                        className={'col-12'}
                        component={BasicSelect}
                        disabled={isGlobalSectionItem}
                    />
                </div>
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                            label={'Description'}
                            placeholder={'Enter a description'}
                            component={VerbRichTextEditor}
                            readOnly={isGlobalSectionItem}
                            rows={3}
                        />
                    </div>
                    <div className={'col-5'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default ChooseOneResultsSectionItem;
